<li class="gHeader-nav-list-item js--element-toggle" id="{{ id }}">
    {{#if href }}
        <a href="{{href}}" class="gHeader-nav-list-item-name js--action-trigger" aria-expanded="false">{{ label }}</a>
    {{else}}
        <div class="gHeader-nav-list-item-name js--action-trigger" aria-expanded="false">{{ label }}</div>
    {{/if}}
    <div class="gHeader-nav-list-item-links">
        <ul class="gHeaderMenu">
            <div class="gHeaderMenu-menuChild">
                <a href="#" class="gHeader-nav-list-item-links-backLink js--action-closeToggle">Back</a>
                <div class="gHeaderMenu-menuChild-subCategoryName">{{ label }}</div>
                <div class="gHeaderMenu-menuChild-content">
                    <div class="gHeaderMenu-menuChild-content-featured">
                            <div class="gHeaderMenu-menuChild-content-featured-menus">
                                <ul class="gHeaderMenu-menuChild-content-featured-menus-secondary">
                                    {{#each children}}
                                        {{#unless (contains label 'Shop All')}}
                                            <li id="{{ id }}">{{#if href}}<a href="{{ href }}" class="gHeaderMenu-menuChild-content-featured-menus-secondary-link">{{ label }}</a>{{else}}{{ label }}{{/if}}
                                                <ul class="gHeaderMenu-menuChild-content-featured-menus-tertiary">
                                                    {{#each children}}
                                                        <li><a href="{{ href }}">{{ label }}</a></li>
                                                    {{/each}}
                                                </ul>
                                            </li>
                                        {{/unless}}
                                    {{/each}}
                                </ul>
                            </div><!-- gHeaderMenu-menuChild-content-featured-menus -->
                        {{#each children}}
                            {{#if (contains label 'Shop All')}}
                                <div class="gHeaderMenu-menuChild-content-featured-shopAll">
                                    <a class="gHeaderMenu-menuChild-content-featured-shopAll-cta" href="{{ href }}">{{ label }}</a>
                                </div>
                            {{/if}}
                        {{/each}}
                    </div><!-- gHeaderMenu-menuChild-content-featured -->
                    {{!-- Foil promo. The CTA is the card's only link; CSS stretches it over the whole card. --}}
                    <div class="gHeaderMenu-menuChild-content-spotlight">
                        <div class="gHeaderMenu-menuChild-content-spotlight-graphic"></div>
                        <div class="gHeaderMenu-menuChild-content-spotlight-bottom">
                            <div class="gHeaderMenu-menuChild-content-spotlight-bottom-title">Foil Printing</div>
                            <p class="gHeaderMenu-menuChild-content-spotlight-bottom-copy">
                                Turn standard into standout with our premium foil finishes. From the classic brilliance of foil Sleeking&trade; to the striking 3D texture of raised foil, give your brand the luxury it deserves.
                            </p>
                            <div class="gHeaderMenu-menuChild-content-spotlight-bottom-ctaContainer">
                                <a class="gHeaderMenu-menuChild-content-spotlight-bottom-ctaContainer-cta" href="/shop/foil-printing">Shop Now</a>
                            </div>
                        </div>
                    </div>
                </div><!-- gHeaderMenu-menuChild-content -->
            </div><!-- gHeaderMenu-menuChild -->
        </ul>
    </div>
</li>
